export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
export const STORAGE_PREFIX = process.env.REACT_APP_STORAGE_PREFIX || 'app';

// Recupera o token respeitando o prefixo do cliente (White Label)
export const getToken = () => localStorage.getItem(`${STORAGE_PREFIX}_token`);

// Centraliza a criação de headers e previne o envio de tokens nulos (Erro 422)
export const getAuthHeaders = (providedToken = null) => {
  const token = providedToken || getToken();
  if (!token) {
    throw new Error('Token ausente. Autenticação necessária.');
  }
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };
};

// Helper para interceptar e tratar sessões expiradas
const handleUnauthorized = (res, logout, navigate) => {
  if (res.status === 401) {
    if (logout) logout();
    if (navigate) navigate('/login');
    throw new Error('Sessão expirada. Faça login novamente.');
  }
};

// --- ENDPOINTS ---

export const fetchBonusConfigs = async (token, navigate, logout) => {
  const res = await fetch(`${API_BASE}/metas_bonus`, {
    headers: getAuthHeaders(token)
  });
  handleUnauthorized(res, logout, navigate);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
};

export const fetchCargos = async (token, navigate, logout) => {
  const res = await fetch(`${API_BASE}/users/cargos`, {
    headers: getAuthHeaders(token)
  });
  handleUnauthorized(res, logout, navigate);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
};

export const saveBonusConfig = async (token, navigate, logout, formData) => {
  const payload = {
    cargo: formData.cargo,
    tipo_video: formData.tipo_video,
    tier: parseInt(formData.tier, 10),
    valor_bonus: parseFloat(formData.valor_bonus),
    views_minimas: parseInt(formData.views_minimas, 10),
    dias_maximos: parseInt(formData.dias_maximos, 10)
  };

  if (Object.values(payload).some(val => val === null || val === undefined || Number.isNaN(val))) {
    throw new Error('Preencha todos os campos corretamente com valores válidos.');
  }

  const url = formData.id
    ? `${API_BASE}/metas_bonus/${formData.id}`
    : `${API_BASE}/metas_bonus`;

  const method = formData.id ? 'PUT' : 'POST';
  const res = await fetch(url, {
    method,
    headers: getAuthHeaders(token),
    body: JSON.stringify(payload)
  });

  handleUnauthorized(res, logout, navigate);

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err?.message || 'Erro ao salvar configuração.');
  }

  return res.json();
};

export const deleteBonusConfig = async (token, navigate, logout, id) => {
  const res = await fetch(`${API_BASE}/metas_bonus/${id}`, {
    method: 'DELETE',
    headers: getAuthHeaders(token)
  });

  handleUnauthorized(res, logout, navigate);
  if (!res.ok) throw new Error('Erro ao excluir configuração.');
  return res.json();
};

export const toggleBonusStatus = async (token, id, novoStatus) => {
  const res = await fetch(`${API_BASE}/metas_bonus/${id}/toggle`, {
    method: 'PATCH',
    headers: getAuthHeaders(token),
    body: JSON.stringify({ ativo: novoStatus })
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err?.message || 'Erro ao alternar status do bônus.');
  }

  return res.json();
};

export const recalcularBonus = async (videoId) => {
  const res = await fetch(`${API_BASE}/videos/${videoId}/recalcular`, {
    method: 'POST',
    headers: getAuthHeaders() // Usa o token do localStorage automaticamente
  });

  if (!res.ok) throw new Error('Erro ao recalcular bônus.');
  return res.json();
};

export const fetchEtapasBonus = async (token, cargo = "", tipo_video = "longo") => {
  const params = new URLSearchParams();
  if (cargo) params.append("cargo", cargo.toUpperCase());
  if (tipo_video) params.append("tipo_video", tipo_video.toLowerCase());

  const res = await fetch(`${API_BASE}/etapas_bonus/?${params.toString()}`, {
    headers: getAuthHeaders(token)
  });
  if (!res.ok) throw new Error('Erro ao buscar etapas bônus.');
  return res.json();
};

export const saveEtapaBonus = async (token, etapaObj) => {
  const res = await fetch(`${API_BASE}/etapas_bonus/`, {
    method: 'POST',
    headers: getAuthHeaders(token),
    body: JSON.stringify({
      cargo: etapaObj.cargo?.toUpperCase() || "",
      etapa: etapaObj.etapa,
      percentual: parseFloat(etapaObj.percentual),
      tipo_video: etapaObj.tipo_video
    })
  });
  if (!res.ok) throw new Error('Erro ao salvar etapa bônus.');
  return res.json();
};

export const toggleEtapaStatus = async (token, id, novoStatus) => {
  const res = await fetch(`${API_BASE}/etapas_bonus/${id}`, {
    method: 'PATCH',
    headers: getAuthHeaders(token),
    body: JSON.stringify({ ativo: novoStatus })
  });

  if (!res.ok) {
    const errorData = await res.json().catch(() => ({ message: 'Erro desconhecido ao alternar status.' }));
    throw new Error(errorData.message);
  }

  return res.json();
};

export const updateEtapaBonus = async (token, id, data) => {
  const res = await fetch(`${API_BASE}/etapas_bonus/${id}`, {
    method: 'PATCH',
    headers: getAuthHeaders(token),
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error('Erro ao atualizar etapa bônus.');
  return res.json();
};

export const deleteEtapaBonus = async (token, id) => {
  const res = await fetch(`${API_BASE}/etapas_bonus/${id}`, {
    method: 'DELETE',
    headers: getAuthHeaders(token),
  });
  if (!res.ok) throw new Error('Erro ao excluir etapa bônus.');
  return res.json();
};